"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var validate_exports = {};
__export(validate_exports, {
  assertPreventKey: () => assertPreventKey,
  preventDefaultKey: () => preventDefaultKey,
  validateViewTag: () => validateViewTag
});
module.exports = __toCommonJS(validate_exports);
function validateViewTag(viewTag) {
  if (!Number.isInteger(viewTag) || viewTag < 1 || viewTag > 2147483647) throw new TypeError("ScreenCapture.captureView requires a positive 32-bit integer view tag");
}
var preventDefaultKey = "default";
function assertPreventKey(key, verb) {
  if (typeof key !== "string" || key.length === 0) throw new TypeError(`ScreenCapture.${verb} requires a non-empty string key`);
}
//# sourceMappingURL=validate.js.map
